import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';
import { getDefaultHeight } from '../utils/get-default-height.js';

const SingleDropzonePlaceholderIcon = svgProps => {
  return /*#__PURE__*/jsxs(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 49 29",
    height: getDefaultHeight(svgProps, 29),
    fill: "none",
    ...svgProps,
    children: [/*#__PURE__*/jsx("path", {
      d: "M16.392 6.014a1 1 0 0 0-.48-1.33L7.764.86a1 1 0 1 0-.85 1.81l7.243 3.399-3.398 7.242a1 1 0 1 0 1.811.85l3.822-8.148ZM4.87 26.568c-1.478-3.864-2.108-7.595-.792-10.94 1.307-3.318 4.644-6.53 11.749-9.098l-.68-1.881C7.764 7.316 3.818 10.828 2.217 14.896c-1.591 4.043-.754 8.363.784 12.386l1.869-.714Z",
      fill: "#E5E6E7"
    }), /*#__PURE__*/jsx("path", {
      d: "M24 7a4 4 0 0 1 4-4h17a4 4 0 0 1 4 4v17a4 4 0 0 1-4 4H28a4 4 0 0 1-4-4V7Z",
      fill: "#090B19",
      fillOpacity: ".06"
    }), /*#__PURE__*/jsx("path", {
      d: "M24 7a4 4 0 0 1 4-4h17a4 4 0 0 1 4 4v17a4 4 0 0 1-4 4H28a4 4 0 0 1-4-4V7Z",
      stroke: "#E5E6E7"
    }), /*#__PURE__*/jsx("path", {
      d: "M24 7a4 4 0 0 1 4-4h8c7.18 0 13 5.82 13 13v8a4 4 0 0 1-4 4H28a4 4 0 0 1-4-4V7Z",
      fill: "#090B19",
      fillOpacity: ".1"
    }), /*#__PURE__*/jsx("path", {
      d: "M36.362 22v-7.152l-1.792 1.808-1.568-1.648 3.728-3.68h2.384V22h-2.752Z",
      fill: "#fff"
    })]
  });
};

export { SingleDropzonePlaceholderIcon };
//# sourceMappingURL=dropzone.single.js.map
